import React from 'react';
import { Card, styled } from '@mui/material';
import { Colors, Text } from 'library';

export function PaymentStatus({ status }: { status: string }) {
    function getText() {
        if (status === 'BLOCKED') {
            return [
                'Due to repeated failed payments or a large unpaid balance, you are no longer able to post jobs.',
                'Your current jobs have either been canceled or are at risk of being canceled.',
                'Please update your payment method and retry payment on the Payments page as soon as possible.',
            ].join(' ');
        }

        return [
            'Your recent payments have failed.',
            'To avoid interruption of Tandem services, please update your payment method and retry payment on the Payments page as soon as possible.',
        ].join(' ');
    }
    return (
        <PayStatusContainer status={status}>
            <Text variant="body2">{getText()}</Text>
        </PayStatusContainer>
    );
}

const PayStatusContainer = styled(Card)(({ status }: { status: string }) => ({
    padding: 20,
    backgroundColor: status === 'BLOCKED' ? Colors.terraCotta : Colors.lightRed,
    borderRadius: 10,
}));
